import React from "react";
import { usePagination, DOTS } from "./usePagination";
import classNames from "classnames";
import "./Pagination.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesLeft, faAnglesRight } from "@fortawesome/free-solid-svg-icons";

const Pagination = ({
  onPageChange,
  totalCount,
  siblingCount = 1,
  currentPage,
  pageSize,
  className,
}) => {
  const paginationRange = structuredClone(
    usePagination({
      currentPage,
      totalCount,
      pageSize,
      siblingCount,
    }),
  );

  if (currentPage === 0 || paginationRange?.length < 2) {
    return null;
  }

  const onStart = () => {
    onPageChange(1);
  };
  const onLast = () => {
    onPageChange(lastPage);
  };

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange?.length - 1];

  return (
    <ul
      className={classNames("pagination-container  p-0", {
        //border
        [className]: className,
      })}
    >
      <li
        className={classNames("pagination-item border rounded-start", {
          //border-end
          disabled: currentPage === 1,
        })}
        onClick={onStart}
      >
        <div className={currentPage === 1 ? "text-secondary" : ""}>
          <FontAwesomeIcon icon={faAnglesLeft} />
        </div>
        {/* <div className="arrow left" /> */}
      </li>
      <li
        className={classNames("pagination-item border", {
          //border-end
          disabled: currentPage === 1,
        })}
        onClick={onPrevious}
      >
        <div className={currentPage === 1 ? "text-secondary" : ""}>Prev</div>
        {/* <div className="arrow left" /> */}
      </li>
      {paginationRange.map((pageNumber, index) => {
        if (pageNumber === DOTS) {
          return (
            //border-end
            <li className="pagination-item border dots" key={index}>
              &#8230;
            </li>
          );
        }

        return (
          <li
            className={classNames("pagination-item border", {
              //border-end
              selected: pageNumber === currentPage,
            })}
            onClick={() => onPageChange(pageNumber)}
            key={index}
          >
            {pageNumber.toLocaleString("en-US")}
          </li>
        );
      })}

      <li
        className={classNames("pagination-item border", {
          //no-border
          disabled: currentPage === lastPage,
        })}
        onClick={onNext}
      >
        <div className={currentPage === lastPage ? "text-secondary" : ""}>
          Next
        </div>
        {/* <div className="arrow right" /> */}
      </li>
      <li
        className={classNames("pagination-item border rounded-end", {
          //no-border
          disabled: currentPage === lastPage,
        })}
        onClick={onLast}
      >
        <div className={currentPage === lastPage ? "text-secondary" : ""}>
          <FontAwesomeIcon icon={faAnglesRight} />
        </div>
        {/* <div className="arrow right" /> */}
      </li>
    </ul>
  );
};

export default Pagination;
